export function getApiBaseUrl(): string {
  const token = localStorage.getItem('token');
  
  // 登录后使用认证 API 域名
  if (token) {
    return process.env.REACT_APP_AUTH_API_URL || 'https://uapi-inipaipos.yehugh.cn';//'http://localhost:4003';//
  }
  
  // 登录前使用未认证 API 域名
  return process.env.REACT_APP_UNAUTH_API_URL || 'https://gapi-inipaipos.yehugh.cn';//'http://localhost:5002';//
}

/**
 * 检查是否已登录
 */
export function isAuthenticated(): boolean {
  return !!localStorage.getItem('token');
}